import { ossToken } from '@/api/upload'

export default {
  state: {
    ossToken: null
  },

  mutations: {
    SET_OSS_TOKEN: (state, ossToken) => {
      state.ossToken = ossToken
    }
  },

  actions: {
    async GetOssToken ({ commit, state }, dir) {
      const response = await ossToken({dir})
      commit('SET_OSS_TOKEN', response.data)
      return true
    }
  }
}
